import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { DollarSign, Download, Mail } from "lucide-react";

const InvoicesCard = ({ invoices = [], formatDate, formatCurrency, onDownloadPdf, onSendEmail }) => {
  const getStatusVariant = (status) => {
    switch (status) {
      case "paid":
        return "secondary";
      case "pending":
        return "default";
      case "pending_approval":
        return "outline";
      case "rejected":
        return "destructive";
      default:
        return "outline";
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "pending_approval":
        return "Pending Approval";
      default:
        return status;
    }
  };

  return (
    <Card data-testid="invoices-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <DollarSign className="h-5 w-5 text-rnb-teal" />
          Invoices
        </CardTitle>
      </CardHeader>
      <CardContent>
        {invoices.length > 0 ? (
          <div className="space-y-3">
            {invoices.map((inv) => (
              <div
                key={inv.invoice_id}
                className="flex items-center justify-between p-4 bg-slate-50 rounded-lg"
                data-testid={`admin-invoice-${inv.invoice_id}`}
              >
                <div>
                  <p className="font-medium text-rnb-navy">{inv.description}</p>
                  <p className="text-sm text-rnb-gray">Due {formatDate(inv.due_date)}</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="text-right">
                    <p className="font-mono-numbers font-semibold text-rnb-navy">
                      {formatCurrency(inv.amount)}
                    </p>
                    <Badge variant={getStatusVariant(inv.status)}>
                      {getStatusLabel(inv.status)}
                    </Badge>
                  </div>
                  <div className="flex gap-1">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onDownloadPdf(inv.invoice_id)}
                      title="Download PDF"
                      data-testid={`admin-download-pdf-${inv.invoice_id}`}
                    >
                      <Download className="h-4 w-4" />
                    </Button>
                    {onSendEmail && ["pending", "paid"].includes(inv.status) && (
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => onSendEmail(inv.invoice_id)}
                        title="Send via Email"
                        data-testid={`admin-email-${inv.invoice_id}`}
                      >
                        <Mail className="h-4 w-4" />
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-rnb-gray py-8">No invoices</p>
        )}
      </CardContent>
    </Card>
  );
};

export default InvoicesCard;
